var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",attrs:{"id":"player-modal","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('player',{ref:"player",attrs:{"player-id":'modal-player-div'}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }